import React, { createContext } from "react";

interface TreeContextType {
  isImparative: boolean;
  state: any[];
  dispatch: React.Dispatch<any>;
  onNodeClick: (node: { 
    state: any[]; 
    name: string; 
    parent?: any; 
    type: string;
    level?: number;
    path?: string;
  }) => void;
}

export const TreeContext = createContext<TreeContextType>({
  isImparative: false,
  state: [],
  dispatch: () => {},
  onNodeClick: () => {}
});

export const useTreeContext = () => React.useContext(TreeContext);
